import { Task } from "./task";

export class BaseTemplateTask  extends Task{
    public baseTemplateTaskId: number;
    public baseTemplateId: number;
    public edhMasterTaskId: number;
}